// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, takeEvery } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";

export const FETCH_CURRENT_PREFERENCES = "saga/FETCH_CURRENT_PREFERENCES";
export const FETCH_CURRENT_PREFERENCES_SUCCESS = "saga/FETCH_CURRENT_PREFERENCES_SUCCESS";
export const FETCH_CURRENT_PREFERENCES_FAILURE = "saga/FETCH_CURRENT_PREFERENCES_FAILURE";
export const UPDATE_DASHBOARD_PREFERENCES = "saga/UPDATE_DASHBOARD_PREFERENCES";
export const UPDATE_DASHBOARD_PREFERENCES_SUCCESS = "saga/UPDATE_DASHBOARD_PREFERENCES_SUCCESS";
export const UPDATE_DASHBOARD_PREFERENCES_FAILURE = "saga/UPDATE_DASHBOARD_PREFERENCES_FAILURE";
export const UPDATE_THEME_PREFERENCES = "saga/UPDATE_THEME_PREFERENCES";
export const UPDATE_THEME_PREFERENCES_SUCCESS = "saga/UPDATE_THEME_PREFERENCES_SUCCESS";
export const UPDATE_THEME_PREFERENCES_FAILURE = "saga/UPDATE_THEME_PREFERENCES_FAILURE";
export const SHOW_SETTINGS = "saga/SHOW_SETTINGS";
export const SHOW_SETTINGS_SUCCESS = "saga/SHOW_SETTINGS_SUCCESS";
export const SHOW_SETTINGS_FAILURE = "saga/SHOW_SETTINGS_FAILURE";

export const actionCreators = {
  fetchCurrentPreferences: createAction(FETCH_CURRENT_PREFERENCES),
  updateDashboardPreferences: createAction(UPDATE_DASHBOARD_PREFERENCES),
  updateThemePreferences: createAction(UPDATE_THEME_PREFERENCES),
  showSettings: createAction(SHOW_SETTINGS)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_PREFERENCES, getCurrentUserData);
  yield takeEvery(UPDATE_DASHBOARD_PREFERENCES, updateDashboardPreferences);
  yield takeEvery(UPDATE_THEME_PREFERENCES, updateThemePreferences);
  yield takeLatest(SHOW_SETTINGS, showSettings);
}

export function* getCurrentUserData(data) {
  try {
    yield put({ type: FETCH_CURRENT_PREFERENCES_SUCCESS, payload: data.payload });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CURRENT_PREFERENCES_FAILURE, error });
  }
}

export function* updateDashboardPreferences(data) {
  try {
    const response = yield call(axios.put, queryParams.apiVersion + "base/set_default_dashboard_modules", {
      dashboard_preferences: data.payload.map(pref => pref.name)
    });
    yield put({ type: UPDATE_DASHBOARD_PREFERENCES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_DASHBOARD_PREFERENCES_FAILURE, error });
  }
}

export function* updateThemePreferences(data) {
  try {
    const response = yield call(axios.put, queryParams.apiVersion + "base/set_default_dashboard_modules", {
      theme: data.payload
    });
    yield put({ type: UPDATE_THEME_PREFERENCES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_THEME_PREFERENCES_FAILURE, error });
  }
}

export function* showSettings(setting) {
  yield put({ type: SHOW_SETTINGS_SUCCESS, payload: setting });
}
